var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "step-content-container flex-level jc-center wp-10" },
    [
      _c(
        "div",
        {
          staticClass: "wp-5 p-8 acenter",
          staticStyle: { "max-width": "640px" }
        },
        [
          _c("onboarding-trial-illustration", {
            attrs: { lang: _vm.currentInterfaceLangId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wp-5 p-8 bl-1 flex-column",
          staticStyle: { "max-width": "640px" }
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("h2", { staticClass: "m-0" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Parlez nous de vous")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 gray-60 m-0 mb-3 semibold" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Editez votre profil Sellsy")) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form onboardingFormGTM",
              attrs: {
                "label-position": "top",
                model: _vm.form,
                rules: _vm.rules
              }
            },
            [
              _vm.errors.get("login")
                ? _c("el-form-item", {
                    attrs: {
                      label: _vm.$t.__(
                        "pages.onboarding.trial.OnboardingTrialStep2.previous_step_error"
                      ),
                      error: _vm.errors.get("login")
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.your_company_name"),
                    prop: "name",
                    error: _vm.errors.get("name")
                  }
                },
                [
                  _c("text-input", {
                    attrs: {
                      mode: "edit",
                      value: _vm.form.name,
                      placeholder: _vm.$t.__(
                        "pages.onboarding.trial.OnboardingTrialStep2.company"
                      )
                    },
                    on: { input: _vm.updateName }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.first_name"),
                    prop: "firstname",
                    error: _vm.errors.get("firstname")
                  }
                },
                [
                  _c("text-input", {
                    attrs: {
                      mode: "edit",
                      value: _vm.form.firstname,
                      placeholder: _vm.$t.__("common.labels.first_name")
                    },
                    on: { input: _vm.updateFirstname }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.name"),
                    prop: "lastname",
                    error: _vm.errors.get("lastname")
                  }
                },
                [
                  _c("text-input", {
                    attrs: {
                      mode: "edit",
                      value: _vm.form.lastname,
                      placeholder: _vm.$t.__("common.labels.name")
                    },
                    on: { input: _vm.updateLastname }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "pages.onboarding.trial.OnboardingTrialStep2.professional_phone"
                    ),
                    prop: "phone_number",
                    error: _vm.errors.get("phone_number")
                  }
                },
                [
                  _c("tel-input", {
                    attrs: {
                      placeholder: "",
                      value: _vm.form.phone_number,
                      "default-country": _vm.form.phone_country
                    },
                    on: {
                      onInput: _vm.updatePhone,
                      onValidate: _vm.onValidateTelInput,
                      onBlur: _vm.onBlurTelInput
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "semibold fs-3 pt-3 mt-0" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Préférence du compte")))
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "pages.onboarding.trial.OnboardingTrialStep2.select_country"
                    ),
                    prop: "country",
                    error: _vm.errors.get("country")
                  }
                },
                [
                  _c("country-input", {
                    attrs: {
                      mode: "edit",
                      defaultValue: { code: _vm.currentLang }
                    },
                    on: { change: _vm.updateCountry }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "pages.onboarding.trial.OnboardingTrialStep2.language"
                    ),
                    prop: "lang",
                    error: _vm.errors.get("lang")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { value: _vm.form.lang },
                      on: { input: _vm.updateLang }
                    },
                    [
                      _c("template", { slot: "prefix" }, [
                        _c("img", {
                          staticClass: "prefix",
                          attrs: {
                            src:
                              "/ressources/public/img/flags/lang/" +
                              _vm.form.lang +
                              ".png"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.availableInterfaceLanguages, function(item) {
                        return _c(
                          "el-option",
                          {
                            key: item.id,
                            attrs: { label: item.label, value: item.id }
                          },
                          [
                            _c("div", { staticClass: "flex flex-level" }, [
                              _c("img", {
                                staticClass: "pr-2",
                                attrs: {
                                  src:
                                    "/ressources/public/img/flags/lang/" +
                                    item.id +
                                    ".png"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.label))])
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action self-center" },
            [
              _c("CompassButton", {
                staticClass: "self-center",
                attrs: {
                  label: _vm.$t.__(
                    "pages.onboarding.trial.OnboardingTrialStep2.save_and_continue"
                  ),
                  type: "primary",
                  disabled: _vm.isDisabledNextStep,
                  loading: _vm.loading
                },
                on: {
                  click: function($event) {
                    return _vm.submitForm("form", "goToNextStep")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }